import { gql } from '@apollo/client';

export const QGL_GET_BILLING = gql`
  query GET_BILLING($month: Int!, $year: Int!) {
    cameras {
      id
      name
      active
      client {
        id
        name
      }
      features {
        record
        fast
        captures
        panoramas
      }
    }
    framesStorageUsage(month: $month, year: $year)
    camerasStats(month: $month, year: $year)
  }
`;

export const QGL_GET_CAMERA_STAT = gql`
  query GET_CAMERA_STAT($cameraId: ID, $month: Int!, $year: Int!) {
    cameraStats(cameraId: $cameraId, month: $month, year: $year) {
      id
      camera {
        id
        name
        timezone
        client {
          id
          name
        }
      }
      month
      live {
        hls {
          notFound
          chunklist {
            count
            bytes
          }
          media {
            count
            bytes
          }
          playlist {
            count
            bytes
          }
          referer
          server
        }
        jpg {
          open {
            count
            bytes
          }
          frame {
            count
            bytes
          }
        }
      }
      record {
        hls {
          notFound
          chunklist {
            count
            bytes
          }
          media {
            count
            bytes
          }
          playlist {
            count
            bytes
          }
          referer
          server
        }
      }
      fastForward {
        hls {
          notFound
          chunklist {
            count
            bytes
          }
          media {
            count
            bytes
          }
          playlist {
            count
            bytes
          }
          referer
          server
          speeds
        }
      }
      frames {
        notFound
        count
        bytes
        referer
        server
        positions
      }
      snapshot {
        redirect
        jpg {
          count
          bytes
          server
          referer
        }
      }
    }
  }
`;
